import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { environment } from 'retail/environments/environment';
import { Observable, from } from 'rxjs';
import { getFromGlobal } from 'shared-ui/di/get-from-global';
import { loadScript } from 'shared-ui/di/load-script';
import { Packeta, Zasilkovna } from 'shared-ui/providers/zasilkovna';

@Injectable({ providedIn: 'root' })
export class ZasilkovnaPickup {
  private client?: Packeta;
  private readonly clientApiKey = environment.zasilkovna.apiKey;
  private readonly defaultOptions: Zasilkovna['Options'] = {
    country: environment.zasilkovna.country,
    language: environment.zasilkovna.language,
  };

  pick(options: Zasilkovna['Options'] = {}): Observable<null | Zasilkovna['Point']> {
    const pickOptions = merge({}, this.defaultOptions, options);
    return from(this.invokePick(pickOptions));
  }

  private async invokePick(options: Zasilkovna['Options']): Promise<null | Zasilkovna['Point']> {
    await this.loadClient();
    return new Promise(resolve => {
      if (!this.client) {
        console.error('Zásilkovna client not loaded');
        resolve(null);
        return;
      }
      this.client.Widget.pick(this.clientApiKey, point => resolve(point), options);
    });
  }

  private async loadClient() {
    if (!this.client) {
      await loadScript(environment.zasilkovna.url);
      this.client = getFromGlobal<Packeta>('Packeta');
    }
  }
}
